import { normalizePartySize } from './normalize-party-size';

export function getSizeGroup(size: number): number {
  return Math.min(4, Math.max(0, Math.floor((normalizePartySize(size) - 1) / 2)));
}
